export const EVENT_START_MINUTES = 15 * 60; // 15:00
export const EVENT_END_MINUTES = 20 * 60; // 20:00 (exclusive)

const pad = (n) => String(n).padStart(2, "0");

export const minutesToTime = (minutes) => `${pad(Math.floor(minutes / 60))}:${pad(minutes % 60)}`;

export const timeToMinutes = (time) => {
  const [hours, minutes] = String(time).split(":").map(Number);
  return hours * 60 + minutes;
};

/**
 * Build "HH:MM" slot labels from `startMinutes` (inclusive) to `endMinutes` (exclusive).
 * Slots whose minute-of-hour equals `excludeMinute` are skipped (the last slot of each hour is a break).
 */
export const buildSlots = (startMinutes, endMinutes, stepMinutes, excludeMinute = null) => {
  const slots = [];
  for (let m = startMinutes; m < endMinutes; m += stepMinutes) {
    if (excludeMinute !== null && m % 60 === excludeMinute) continue;
    slots.push(minutesToTime(m));
  }
  return slots;
};

/** Czech plural for participants: 1 účastník, 2–4 účastníci, 5+ účastníků. */
export const participantLabel = (count) => {
  if (count === 1) return "účastník";
  if (count < 5) return "účastníci";
  return "účastníků";
};

/** Czech plural for team members: 1 člena, 2+ členy. */
export const memberLabel = (count) => (count === 1 ? "člena" : "členy");
